import { getCustomerById } from 'client/api/customer'
import { CustomerInterface } from 'client/Interfaces/CustomerInterface'

export default async function useGetCustomer(id: number): Promise<CustomerInterface> {
  const res = await getCustomerById(id)
  return res
}
